// import AlliedCamera from '../../routes/SmartInspect/Warren/assets/maintenance/5.1-allied-camera.png';
// import AlliedConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.2-allied-camera-connections.png';
import ChannelBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.3-channel-board.png';
import LEDHeader from '../../routes/SmartInspect/Warren/assets/maintenance/5.4-LED-header-board.png';
// import ArchDoubleWide from '../../routes/SmartInspect/Warren/assets/maintenance/5.5-arch-double-wide-LED.png';
// import ArchBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.6-arch-light-boards.png';
// import WideBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.7-LED-wide-light-boards.png';
// import ArchConnecions from '../../routes/SmartInspect/Warren/assets/maintenance/5.8-light-arch-connections.png';
// import DoubleWideConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.9-double-wide-connections.png';
// import TriggerBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.10-trigger-board-connections.png';
import ArchHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.11-arch-light-housing.png';
import DoubleHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.12-double-wide-housing.png';
import styled from 'styled-components';
import BSCarousel from 'react-bootstrap/Carousel';

const CarouselComp = ({ className }) => {
	return (
		<BSCarousel className={className} fade variant="dark" interval={null}>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 1</h3>
					<p>
						Remove the associated clamp brackets from the upstream side of the light housing or housings by removing the metric Allen screws on each clamp bracket (see <b>Figure 1, Figure 2</b>). Spread the bracket apart to release.{' '}
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 2</h3>
					<p>Slide the complete light housing out of the other half of the clamp bracket by pulling gently outward until the entire housing is free. While removing the light housing make note to feed the channel board to LED board power cable through the pass-through hole in the bottom of the light box.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 3</h3>
					<p>
						Remove the LED light board assembly by sliding the five segment LED light out of the housing (see <b>Figure 1: LED Header Board Connections</b>). Make note of what grove the boards are sitting in within the housing as this is the grove you will use for installation.
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 4</h3>
					<p>Gently separate the bad LED segment board or boards from the other boards by grasping on either side of the board and pulling apart. Be careful not to break the LED board joining pins/header connector.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 5</h3>
					<p>Replace the bad LED board segments with new segments by aligning the pins/header connectors and locking them together.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 6</h3>
					<p>Ensure the two black connectors on the back of the LED header board have not come undone before installing the boards completely back into the housing, make sure not to pinch any of the wires.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 7</h3>
					<p>Install the 5 segment LED light with the header/power cable first into the housing within the grove notated in step 3. Make sure the LEDs are facing out.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 8</h3>
					<p>Slide the complete light housing back into the other half of the clamp bracket by pushing gently inward until the entire housing is secured and butted up against the face of the clamp bracket. While installing the light housing make note to feed the channel board to LED board power cable through the pass-through hole in the bottom of the light box.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 9</h3>
					<p>
						Install the associated clamp brackets back onto the upstream side of the light housing or housings by installing the metric Allen screws (see <b>Figure 1, Figure 2</b>). Make sure to align the grooves within the housing to the clamp bracket to ensure a proper fit.
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 10</h3>
					<p>
						Connect the two black three pin LED board power VDC and ground GND connectors onto the channel board associated with the light that had the bad LED board (see <b>Figure 1: Channel Board Connections</b>).
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 11</h3>
					<p>
						Install the LED light diffuser lens by lying it flat against the face of the light housing and press the two black locking strips on either side of the light housing into place securing the diffuser lens to the housing (see <b>Figure 1: Arch Light LED Board Housing Components</b>). Use clean gloves when working with the diffuser lens, it is very important not to scratch, crease or damage the lens during removal/installation. If damage occurs contact Inovision for a replacement
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 12</h3>
					<p>Install the light box cover with the two before remove metric Allen screws. Make sure not to pinch any of the wires while installing the cover.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 12</h3>
					<p>Install the light box cover with the two before remove metric Allen screws. Make sure not to pinch any of the wires while installing the cover.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 13</h3>
					<p>Connect the associated power and trigger cables back onto to the light box bulkhead ports by aligning the connector notch and screwing them in clockwise until fully seated. Make note of the labels on the bulkhead and ensure the correct cable goes to the associated port.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 14</h3>
					<p>Perform unlock procedure and restore power to the system.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
		</BSCarousel>
	);
};

const AlliedCameraSMP = styled(CarouselComp)`
	width: 65vw;
	margin: 0 auto;

	.carousel-inner {
		border-radius: 2em;
		min-height: 50vh;
	}

	.carousel-indicators {
		bottom: -20px;
	}

	.carousel-caption {
		position: relative;
		background: white;
		color: #000;
		width: 100%;
		left: 0;
		right: 0;
		bottom: 0;

		& h3 {
			text-align: center;
		}
	}
	@media screen and (max-width: 480px) {
		width: 89vw;
	}
`;

export default AlliedCameraSMP;
